import { useMatch } from 'react-router-dom';

import routes from 'core/routes';

const useLayoutEditorParams = (): string => {
  const match = useMatch(routes.dashboard.settings.objects.details.layoutEditor.toString());
  const { moduleName } = match?.params as { moduleName: string };

  return moduleName;
};

export default useLayoutEditorParams;
